import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Route,
  Routes,
  BrowserRouter as Router,
  Navigate,
} from "react-router-dom";

import About from "./Pages/About/About";
import Blog from "./Pages/Blog/Blog";
import BlogDetail from "./Pages/BlogDetail/BlogDetail";
import Checkout from "./Pages/Checkout/Checkout";
import Contact from "./Pages/Contact/Contact";
import CourseDetail from "./Pages/CourseDetail/CourseDetail";
import CustomerSpeak from "./Pages/CustomerSpeak/CustomerSpeak";
import Home from "./Pages/Home/Home";
import Instructor from "./Pages/Instructor/Instructor";
import Partner from "./Pages/Partner/Partner";
import Privacy from "./Pages/Privacy/Privacy";
import Resources from "./Pages/Resources/Resources";
import Terms from "./Pages/Terms/Terms";
import ViewSchedule from "./Pages/ViewSchedule/ViewSchedule";

import Corporate from "./Pages/Corporate/Corporate";
import ComplaintHandlingPolicy from "./Pages/ComplaintHandlingPolicy/ComplaintHandlingPolicy";
import CancellationAndRefundPolicy from "./Pages/CancellationAndRefundPolicy/CancellationAndRefundPolicy";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Demo from "./Pages/Demo/Demo";
import Test from "./Pages/Test/Test";
import Thankyou from "./Pages/ThankYou/ThankYou";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route exact path="/" element={<Home />} />

          <Route exact path="/about-us" element={<About />} />
          <Route exact path="/blogs" element={<Blog />} />
          <Route exact path="/blog/:seo_slug" element={<BlogDetail />} />
          <Route exact path="/checkout" element={<Checkout />} />
          <Route exact path="/contact-us" element={<Contact />} />
          <Route
            path="/safe/leading-safe®-6.0-training-with-safe-agile-certification"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/safe/safe-advanced-scrum-master-(sasm)-certification-training-"
            element={
              <Navigate
                to="/safe/safe-advanced-scrum-master-certification-training"
                replace
              />
            }
          />

          <Route
            path="/safe/safe-product-owner-product-manager-(popm)-certification-training"
            element={
              <Navigate
                to="/safe/safe-product-owner-product-manager-popm-certification"
                replace
              />
            }
          />

          <Route
            path="/safe/safe®-scrum-master-(ssm)-certification-training"
            element={
              <Navigate to="/safe/safe-scrum-master-certification" replace />
            }
          />

          {/*  */}

          {/* <Route
            path="/courses/agile-fundamentals-training-and-certification/undefined"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          /> */}

          <Route
            path="/courses/leading-safe-training-and-certification/leading-safe-training-certification-in-ahmedabad/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-system-design-kmp1-training-and-certification/kanban-system-design-training-in-coimbatore/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-delhi/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/leading-safe-training-and-certification/leading-safe-training-certification-in-vadodara/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-chennai/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/leading-safe-training-and-certification/leading-safe-training-certification-in-delhi/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-bhubaneswar/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-system-design-kmp1-training-and-certification/kanban-system-design-training-in-visakhapatnam/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-jaipur/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/csm-certification-training-online/undefined"
            element={
              <Navigate
                to="/agile-and-scrum/certified-scrum-master-csm-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-nashik/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-delhi/undefined"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-nashik/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-jaipur/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-gurgaon/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/CSM-Certification-Training-Online/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-scrum-master-csm-certification-training"
                replace
              />
            }
          />

          <Route
            path="/safe/safe®-product-owner-product-manager-(popm)-certification-training/"
            element={
              <Navigate
                to="/safe/safe-product-owner-product-manager-popm-certification"
                replace
              />
            }
          />

          <Route
            path="/courses/agile-product-management-training-and-certification/"
            element={
              <Navigate
                to="/safe/safe-product-owner-product-manager-popm-certification"
                replace
              />
            }
          />

          {/* <Route
            path="/courses/agile-fundamentals-training-and-certification/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          /> */}

          <Route
            path="/courses/kanban-system-design-kmp1-training-and-certification/"
            element={
              <Navigate
                to="/kanban/kanban-system-design-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-training-and-certification/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/team-kanban-practitioner-tkp-training-and-certification/"
            element={
              <Navigate
                to="/kanban/kanban-system-design-certification-training"
                replace
              />
            }
          />

          {/* <Route
            path="/courses/safe-productowner-training-and-certification/"
            element={
              <Navigate
                to="/safe/safe-product-owner-product-manager-popm-certification"
                replace
              />
            }
          /> */}

          <Route path="/courses/" element={<Navigate to="/" replace />} />

          {/* <Route
            path="/courses/scrum-fundamentals-training-and-certification/"
            element={
              <Navigate to="/safe/safe-scrum-master-certification" replace />
            }
          /> */}

          {/* New Redirect Add Multiple Start */}

          <Route
            path="/courses/safe-for-teams-certification-training-in-bangalore/undefined"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-bangalore"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-coimbatore/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-hyderabad/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-noida/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-chennai/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/leading-safe-training-and-certification/leading-safe-training-certification-in-chandigarh/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-kolkata/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-training-and-certification/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/scrum-fundamentals-training-and-certification/"
            element={
              <Navigate
                to="/safe/safe-advanced-scrum-master-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-productowner-training-and-certification/"
            element={
              <Navigate
                to="/safe/safe-product-owner-product-manager-popm-certification"
                replace
              />
            }
          />

          <Route
            path="/courses/team-kanban-practitioner-tkp-training-and-certification/"
            element={
              <Navigate
                to="/kanban/kanban-system-design-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-system-design-kmp1-training-and-certification/"
            element={
              <Navigate
                to="/kanban/kanban-system-design-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-delhi/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/leading-safe-training-and-certification/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-gurgaon/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-pune/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/CSM-Certification-Training-Online/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-scrum-master-csm-certification-training"
                replace
              />
            }
          />

          <Route
            path="/corporate-training-and-certification-agile-safe-scrum-master/"
            element={
              <Navigate
                to="/safe/safe-advanced-scrum-master-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/agile-product-management-training-and-certification/"
            element={
              <Navigate
                to="/safe/safe-product-owner-product-manager-popm-certification"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-bangalore/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/agile-fundamentals-training-and-certification/"
            element={
              <Navigate
                to="/safe/safe-product-owner-product-manager-popm-certification"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-patna/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/csm-certification-training-online/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-scrum-master-csm-certification-training"
                replace
              />
            }
          />

          <Route path="/free-e-books/" element={<Navigate to="/" replace />} />

          <Route path="/clients-voice/" element={<Navigate to="/" replace />} />

          <Route
            path="/courses/safe-for-teams-certification-training-in-trivandrum/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-surat/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-coimbatore/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-private-classes-only-training-and-certification/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/kanban-systems-improvement-kmp2/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-coimbatore/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-cochin/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-system-design-kmp1-training-and-certification/kanban-system-design-training-in-pune/"
            element={
              <Navigate
                to="/kanban/kanban-system-design-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-patna/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-visakhapatnam/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-indore/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/leading-safe-training-and-certification/leading-safe-training-certification-in-goa/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-gurgaon/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/leading-safe-training-and-certification/leading-safe-training-certification-in-chennai/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/leading-safe-training-and-certification/leading-safe-training-certification-in-visakhapatnam/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/advanced-scrum-master-training-and-certification/"
            element={
              <Navigate
                to="/safe/safe-advanced-scrum-master-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-delhi/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-trivandrum/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-ahmedabad/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-bangalore/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-surat/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-chennai/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/kanban-system-design-kmp1/"
            element={
              <Navigate
                to="/kanban/kanban-system-design-certification-training"
                replace
              />
            }
          />

          <Route
            path="/about-surya-gandi/"
            element={<Navigate to="/" replace />}
          />

          <Route
            path="/courses/leading-safe-training-and-certification/leading-safe-training-certification-in-mumbai/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-system-design-kmp1-training-and-certification/kanban-system-design-training-in-hyderabad/"
            element={
              <Navigate
                to="/kanban/kanban-system-design-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-mumbai/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-hyderabad/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-chennai/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/ot_footer_builders/footer-v1/"
            element={<Navigate to="/" replace />}
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-cochin/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-system-design-kmp1-training-and-certification/kanban-system-design-training-in-indore/"
            element={
              <Navigate
                to="/kanban/kanban-system-design-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-system-design-kmp1-training-and-certification/kanban-system-design-training-in-noida/"
            element={
              <Navigate
                to="/kanban/kanban-system-design-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/leading-safe-training-and-certification/leading-safe-training-certification-in-patna/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-kolkata/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/leading-safe-training-and-certification/leading-safe-training-certification-in-surat/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/leading-safe-training-and-certification/leading-safe-training-certification-in-gurgaon/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-trivandrum/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/ot_footer_builders/footer-v3/"
            element={<Navigate to="/" replace />}
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-kolkata/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-chandigarh/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-gurgaon/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/leading-safe-training-and-certification/leading-safe-training-certification-in-pune/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-bangalore/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-surat/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-system-design-kmp1-training-and-certification/kanban-system-design-training-in-kolkata/"
            element={
              <Navigate
                to="/kanban/kanban-system-design-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-system-design-kmp1-training-and-certification/kanban-system-design-training-in-mumbai/"
            element={
              <Navigate
                to="/kanban/kanban-system-design-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-bhubaneswar/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-chandigarh/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-visakhapatnam/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-system-design-kmp1-training-and-certification/kanban-system-design-training-in-bhubaneswar/"
            element={
              <Navigate
                to="/kanban/kanban-system-design-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-team-training-certification-in-ahmedabad/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-chandigarh/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-cochin/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-bangalore/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-visakhapatnam/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-goa/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-vadodara/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-pune/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-pune/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-noida/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-goa/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-mumbai/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-trivandrum/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-systems-improvement-kmp2-training-and-certification/kanban-systems-improvement-kmp2-training-certification-in-indore/"
            element={
              <Navigate
                to="/kanban/kanban-management-professional-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-nashik/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-surat/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-bhubaneswar/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/modalpopupbox/contact-form/"
            element={<Navigate to="/" replace />}
          />

          <Route
            path="/courses/release-train-engineer-training-certification-patna/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-mumbai/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-vadodara/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-mumbai/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/safe-for-teams-certification-training-in-jaipur/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/leading-safe-training-and-certification/leading-safe-training-certification-in-jaipur/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-system-design-kmp1-training-and-certification/kanban-system-design-training-in-chandigarh/"
            element={
              <Navigate
                to="/kanban/kanban-system-design-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/kanban-system-design-kmp1-training-and-certification/kanban-system-design-training-in-jaipur/"
            element={
              <Navigate
                to="/kanban/kanban-system-design-certification-training"
                replace
              />
            }
          />

          <Route
            path="/copyright-policy/"
            element={<Navigate to="/" replace />}
          />

          <Route
            path="/icp-acc-training-certification-in-bhubaneswar/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-goa/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-indore/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route path="/trainer-login/" element={<Navigate to="/" replace />} />

          <Route
            path="/courses/safe-for-teams-certification-training-in-chandigarh/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route path="/my-account/" element={<Navigate to="/" replace />} />

          <Route path="/shop/" element={<Navigate to="/" replace />} />

          <Route
            path="/courses/safe-for-teams-certification-training-in-indore/"
            element={
              <Navigate
                to="/safe/leading-safe-agilist-certification-training"
                replace
              />
            }
          />

          <Route path="/modalpopupbox/" element={<Navigate to="/" replace />} />

          <Route
            path="/icp-acc-training-certification-in-vadodara/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/icp-acc-training-certification-in-ahmedabad/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/the-scrum-2020/"
            element={<Navigate to="/" replace />}
          />

          <Route path="/take-quiz/" element={<Navigate to="/" replace />} />

          <Route
            path="/icp-acc-training-certification-in-kolkata/"
            element={
              <Navigate
                to="/agile-and-scrum/certified-agile-coach-icp-acc-certification-training"
                replace
              />
            }
          />

          <Route
            path="/courses/release-train-engineer-training-certification-coimbatore/"
            element={
              <Navigate
                to="/safe/safe-release-train-engineer-certification-training"
                replace
              />
            }
          />

          <Route path="/cart/" element={<Navigate to="/" replace />} />

          {/* New Redirect Add Multiple End */}

          <Route
            exact
            path="/:category_seo_slug/:seo_slug"
            element={<CourseDetail />}
          />
          <Route exact path="/customer-speak" element={<CustomerSpeak />} />
          <Route exact path="/home" element={<Home />} />
          <Route exact path="/become-an-instructor" element={<Instructor />} />
          <Route exact path="/partner-with-us" element={<Partner />} />
          <Route exact path="/privacy-policy" element={<Privacy />} />
          <Route exact path="/resources" element={<Resources />} />
          <Route exact path="/terms-and-conditions" element={<Terms />} />
          <Route exact path="/thankyou" element={<Thankyou />} />
          <Route
            exact
            path="/view-schedule/:courseId"
            element={<ViewSchedule />}
          />

          <Route exact path="/corporate" element={<Corporate />} />
          <Route
            exact
            path="/complaint-handling-policy"
            element={<ComplaintHandlingPolicy />}
          />
          <Route
            exact
            path="/cancellation-and-refund-policy"
            element={<CancellationAndRefundPolicy />}
          />

          <Route exact path="/demo" element={<Demo />} />
          <Route exact path="/test" element={<Test />} />
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Router>
    </>
  );
}

export default App;
